export const MAX_LEAD_DETAILS = 50;
export const MAX_DETAIL_NAME_LENGTH = 100;
export const MAX_DETAIL_VALUE_LENGTH = 2000;

let nextRowId = 0;
export function createDetailRow(detail = {}) {
  return { id: `lead-detail-${++nextRowId}`, key: detail.key ?? "", value: detail.value ?? "" };
}

export function detailsToRows(details = []) {
  return (Array.isArray(details) ? details : []).map(createDetailRow);
}

export function detailsFromRows(rows) {
  return rows.map(({ key, value }) => ({ key: key.trim(), value: value.trim() }))
    .filter(({ key, value }) => key || value);
}

export function validateAdditionalDetails(rows) {
  const errors = {};
  const names = new Map();
  for (const row of rows) {
    const key = row.key.trim();
    const value = row.value.trim();
    if (!key && !value) continue;
    const rowErrors = {};
    if (!key) rowErrors.key = "Enter a detail name.";
    if (!value) rowErrors.value = "Enter a value.";
    if (key.length > MAX_DETAIL_NAME_LENGTH) rowErrors.key = "Use up to 100 characters for the name.";
    if (value.length > MAX_DETAIL_VALUE_LENGTH) rowErrors.value = "Use up to 2,000 characters for the value.";
    const name = key.toLowerCase();
    if (key && names.has(name)) {
      rowErrors.key = "This detail name is already used.";
      const previousId = names.get(name);
      errors[previousId] = { ...errors[previousId], key: rowErrors.key };
    }
    if (key) names.set(name, row.id);
    if (Object.keys(rowErrors).length) errors[row.id] = { ...errors[row.id], ...rowErrors };
  }
  return { errors, message: rows.length > MAX_LEAD_DETAILS ? "A lead can have up to 50 additional details." : "" };
}

export function additionalDetailsApiError(error) {
  const messages = Object.values(error?.response?.data?.errors || {}).flat();
  return messages.length ? messages.join(" ") : error?.response?.data?.message || "Unable to save these details. Your changes are still here; please try again.";
}
